export const babas = [
  {
    id: 1,
    name: "Premanand Ji Maharaj",
    title: "Vrindavan Ke Vaishnav Sant",
    location: "Vrindavan, Uttar Pradesh",
    born: "1950s",
    image: "/premanand1.jpg",
    shortDesc: "Vrindavan mein rehne wale prasiddh Vaishnav sant, bhakti aur satsang ke liye jaane jaate hain",
    fullDesc: "Premanand Ji Maharaj Vrindavan ke ek prasiddh Vaishnav sant hain jo Radha-Krishna ki bhakti mein apna jeevan samarpit kar chuke hain. Woh apne pravachano mein bhakti, vairagya aur Bhagwat Geeta ka sandesh dete hain. Unke satsang mein lakho log aate hain aur unka YouTube channel bhi bahut popular hai. Woh sadgi aur satya ke prateek maane jaate hain.",
    work: ["Bhakti pravachan", "Radha-Krishna katha", "Satsang aayojan", "Vairagya ka sandesh", "Gita pravachan"],
    followers: "2 Crore+",
    youtube: "Premanand Ji Maharaj",
    category: "Vaishnav Sant",
    color: "#FF8C00",
    bgColor: "from-yellow-900 to-orange-700"
  },
  {
    id: 2,
    name: "Dhirendra Krishna Shastri",
    title: "Bageshwar Dham Sarkar",
    location: "Chhatarpur, Madhya Pradesh",
    born: "4 July 1996",
    image: "/b5.jpg",
    shortDesc: "Bageshwar Dham ke peethadhishwar, divya darbar aur chamatkar ke liye prasiddh",
    fullDesc: "Dhirendra Krishna Shastri, jinhein 'Bageshwar Dham Sarkar' ke naam se jaana jaata hai, Madhya Pradesh ke Chhatarpur jile mein sthit Bageshwar Dham ke peethadhishwar hain. Woh apne 'divya darbar' ke liye prasiddh hain jahan woh log ki samasya bina bataye bata dete hain. Unka maanna hai ki yeh shakti unhe Hanuman ji aur Bageshwar Dham se milti hai. Unke darbar mein lakho shraddhalu aate hain.",
    work: ["Divya Darbar aayojit karna", "Sanatan Dharma ka prachar", "Garib logo ki madad", "Bhoot-pret nivaran", "Katha-pravachan"],
    followers: "5 Crore+",
    youtube: "Bageshwar Dham Sarkar",
    category: "Katha Vachak",
    color: "#FF6B00",
    bgColor: "from-orange-900 to-amber-700"
  },
  {
    id: 3,
    name: "Jaya Kishori Ji",
    title: "Katha Vachika - Rajasthan Ki Meera",
    location: "Rajasthan",
    born: "13 July 1995",
    image: "/jayakishori1.jpg",
    shortDesc: "Sabse yuva aur prasiddh katha vachika, 'Rajasthan ki Meera' ke naam se jaani jaati hain",
    fullDesc: "Jaya Kishori Ji ek bahut hi yuva aur prasiddh katha vachika hain. Woh Bhagwat Katha, Ramayan aur bhajano ke liye jaani jaati hain. Unhe 'Rajasthan ki Meera' bhi kaha jaata hai. Unke YouTube channel par croro subscribers hain. Woh yuvaon mein adhyatm ki jyot jagane ka kaam kar rahi hain.",
    work: ["Bhagwat Katha", "Bhajan gaana", "Ramayan pravachan", "YouTube content", "Yuva prerna"],
    followers: "4 Crore+",
    youtube: "Jaya Kishori",
    category: "Katha Vachika",
    color: "#FF9900",
    bgColor: "from-yellow-900 to-orange-600"
  },
  {
    id: 4,
    name: "Indresh Upadhyay",
    title: "Vrindavan Ke Prasiddh Sant",
    location: "Vrindavan, Mathura (U.P.)",
    born: "1960s",
    image: "/indresh1.jpg",
    shortDesc: "Vrindavan ke prasiddh sant, bhakti aur adhyatm ke pracharak",
    fullDesc: "Indresh Upadhyay Ji Vrindavan ke ek prasiddh sant hain. Woh bhakti aur adhyatm ke prachar mein lage hue hain. Unke pravachan mein Radha-Krishna ki bhakti aur Sanatan Dharma ka sandesh hota hai.",
    work: ["Bhakti pravachan", "Satsang aayojan", "Dharm prachar", "Adhyatmik shiksha", "Seva kaarya"],
    followers: "1 Crore+",
    youtube: "Indresh Upadhyay",
    category: "Vaishnav Sant",
    color: "#CC4400",
    bgColor: "from-stone-900 to-amber-800"
  },
  {
    id: 5,
    name: "Sri Sri Ravi Shankar",
    title: "Art of Living Ke Sansthapak",
    location: "Bangalore, Karnataka",
    born: "13 May 1956",
    image: "/sri sri ravi.jpg",
    shortDesc: "Art of Living Foundation ke sansthapak, Sudarshan Kriya ke pravartak",
    fullDesc: "Sri Sri Ravi Shankar Art of Living Foundation ke sansthapak hain. Unhone Sudarshan Kriya ki khoj ki jo ek vishesh pranayam technique hai. Unka Art of Living ashram Bangalore mein hai. Woh vishwa shanti ke liye kaam karte hain aur conflict resolution mein bhi unka yogdan hai. Unke courses duniya ke 180+ deshon mein chalte hain.",
    work: ["Sudarshan Kriya shiksha", "Art of Living courses", "Vishwa shanti prayas", "Conflict resolution", "Manav seva"],
    followers: "8 Crore+",
    youtube: "Art of Living",
    category: "Spiritual Guru",
    color: "#FF5500",
    bgColor: "from-orange-900 to-red-700"
  },
  {
    id: 6,
    name: "Baba Ramdev",
    title: "Yoga Guru aur Patanjali Ke Sansthapak",
    location: "Haridwar, Uttarakhand",
    born: "25 December 1965",
    image: "/Ramdev.jpg",
    shortDesc: "Yoga ko ghar ghar pahunchane wale, Patanjali Ayurved ke sansthapak",
    fullDesc: "Baba Ramdev ka poora naam Ramkrishna Yadav hai. Unhone yoga ko aam janta tak pahunchaya. Unke TV shows aur yoga shivir mein croro log participate karte hain. Unhone Patanjali Ayurved ki sthapna ki jo aaj ek badi company ban gayi hai. Woh swadeshi andolan ke bhi prabal samarthak hain.",
    work: ["Yoga shiksha", "Patanjali Ayurved", "Swadeshi andolan", "Pranayam prachar", "Ayurvedic products"],
    followers: "20 Crore+",
    youtube: "Patanjali Yogpeeth",
    category: "Yoga Guru",
    color: "#FF7700",
    bgColor: "from-amber-900 to-yellow-700"
  },
  {
    id: 7,
    name: "Devkinandan Thakur Ji",
    title: "Bhagwat Katha Vachak",
    location: "Vrindavan, Uttar Pradesh",
    born: "1970s",
    image: "/devkinand.jpg",
    shortDesc: "Bhagwat Katha ke prasiddh vachak, Hindu dharm ke prabal samarthak",
    fullDesc: "Devkinandan Thakur Ji Bhagwat Katha ke ek prasiddh vachak hain. Woh apni katha mein Bhagwat Puran ki kahaniyon ko bahut hi ras aur bhav se sunate hain. Unke pravachan mein lakho shraddhalu aate hain. Woh Hindu dharm ki raksha ke liye bhi sada taiyar rehte hain aur samajik muddon par bhi apni baat rakhte hain.",
    work: ["Bhagwat Katha", "Dharm prachar", "Hindu jagran", "Satsang aayojan", "Pravachan"],
    followers: "3 Crore+",
    youtube: "Devkinandan Thakur Ji",
    category: "Katha Vachak",
    color: "#FF6600",
    bgColor: "from-orange-900 to-amber-600"
  },
  {
    id: 8,
    name: "Sadhguru Jaggi Vasudev",
    title: "Isha Foundation Ke Sansthapak",
    location: "Coimbatore, Tamil Nadu",
    born: "3 September 1957",
    image: "/jagi.jpg",
    shortDesc: "Isha Foundation ke sansthapak, yoga aur adhyatm ke vishwa prasiddh guru",
    fullDesc: "Sadhguru Jaggi Vasudev ek prasiddh yogi, mystic aur Isha Foundation ke sansthapak hain. Unka Isha Yoga Center Coimbatore mein sthit hai. Woh yoga, meditation aur adhyatm ko aadhunik tarike se samjhate hain. Unka 'Save Soil' abhiyan vishwa star par bahut prasiddh hua. Woh TED talks aur international forums mein bhi bhaag lete hain.",
    work: ["Yoga shiksha", "Isha Foundation chalana", "Save Soil abhiyan", "International pravachan", "Adhyatmik retreat"],
    followers: "15 Crore+",
    youtube: "Sadhguru",
    category: "Yogi",
    color: "#CC4400",
    bgColor: "from-stone-900 to-amber-800"
  },
  {
    id: 9,
    name: "Morari Bapu",
    title: "Ram Katha Vachak",
    location: "Talgajarda, Gujarat",
    born: "25 September 1946",
    image: "/bapu.jpg",
    shortDesc: "Ram Katha ke vishwa prasiddh vachak, 9 din ki Ram Katha ke liye jaane jaate hain",
    fullDesc: "Morari Bapu ka poora naam Rameshbhai Prabhudasbhai Hariyani hai. Woh Ram Katha ke vishwa prasiddh vachak hain. Unki 9 din ki Ram Katha duniya bhar mein aayojit hoti hai. Woh Ramcharitmanas ki vyakhya bahut hi saral aur prabhavshali tarike se karte hain. Unka maanna hai ki Satya, Prem aur Karuna hi dharm ka aadhar hai.",
    work: ["Ram Katha pravachan", "Ramcharitmanas vyakhya", "Samajik seva", "Vishwa shanti sandesh", "Sahitya lekhan"],
    followers: "10 Crore+",
    youtube: "Morari Bapu",
    category: "Katha Vachak",
    color: "#E65C00",
    bgColor: "from-red-900 to-orange-700"
  },
  {
    id: 10,
    name: "Pundrik Goswami Ji",
    title: "Vaishnav Acharya",
    location: "Vrindavan, Uttar Pradesh",
    born: "1960s",
    image: "/pundrik goswami ji.jpg",
    shortDesc: "Vrindavan ke prasiddh Vaishnav Acharya, Radha-Krishna bhakti ke pracharak",
    fullDesc: "Pundrik Goswami Ji Vrindavan ke ek prasiddh Vaishnav Acharya hain. Woh Radha-Krishna ki bhakti aur Vaishnav sampraday ke prachar mein lage hue hain. Unke pravachan mein bhakti, prem aur seva ka sandesh hota hai. Woh Vrindavan ki seva aur parikrama ke liye bhi jaane jaate hain.",
    work: ["Vaishnav pravachan", "Radha-Krishna seva", "Vrindavan parikrama", "Bhakti shiksha", "Satsang"],
    followers: "1 Crore+",
    youtube: "Pundrik Goswami",
    category: "Vaishnav Sant",
    color: "#FF8800",
    bgColor: "from-yellow-900 to-amber-700"
  },
  {
    id: 11,
    name: "Swami Vivekananda",
    title: "Ramakrishna Mission Ke Sansthapak",
    location: "Kolkata, West Bengal",
    born: "12 January 1863 - 4 July 1902",
    image: "/SWAMI VIVEKANANDA.jpg",
    shortDesc: "Ramakrishna Mission ke sansthapak, Chicago mein 'Brothers and Sisters of America' speech ke liye prasiddh",
    fullDesc: "Swami Vivekananda Ramakrishna Paramahamsa ke shishya the. 1893 mein Chicago mein World Parliament of Religions mein unke bhashan ne poori duniya ko Hinduism se parichit karaya. Unhone Ramakrishna Mission ki sthapna ki. Unka maanna tha ki seva hi pooja hai. Woh yuvaon ke prerna strot hain.",
    work: ["Vedanta prachar", "Ramakrishna Mission", "Manav seva", "Yuva prerna", "Vishwa dharm prachar"],
    followers: "Vishwa Prasiddh",
    youtube: "Ramakrishna Math",
    category: "Vedanta Guru",
    color: "#FF5000",
    bgColor: "from-amber-900 to-red-700"
  },
  {
    id: 12,
    name: "Gaur Gopal Das",
    title: "ISKCON Monk aur Life Coach",
    location: "Mumbai, Maharashtra",
    born: "1973",
    image: "/gaur.jpg",
    shortDesc: "ISKCON monk aur international life coach, aadhunik bhasha mein adhyatm sikhate hain",
    fullDesc: "Gaur Gopal Das ek ISKCON monk aur international life coach hain. Woh pehle HP mein engineer the, phir ISKCON join kiya. Unke motivational talks mein adhyatm aur aadhunik jeevan ka sundar sangam hota hai. Unki book 'Life's Amazing Secrets' bestseller rahi. Woh TEDx talks bhi dete hain.",
    work: ["Life coaching", "ISKCON seva", "Motivational talks", "Book lekhan", "International pravachan"],
    followers: "3 Crore+",
    youtube: "Gaur Gopal Das",
    category: "ISKCON Monk",
    color: "#FF6000",
    bgColor: "from-orange-900 to-amber-700"
  },
  {
    id: 13,
    name: "Aniruddhacharya Ji",
    title: "Yuva Bhagwat Katha Vachak",
    location: "Vrindavan, Uttar Pradesh",
    born: "1980s",
    image: "/anurudh.jpg",
    shortDesc: "Yuva Bhagwat Katha vachak, social media par bahut popular",
    fullDesc: "Aniruddhacharya Ji ek yuva aur prasiddh Bhagwat Katha vachak hain. Woh apni katha mein aadhunik udaahrano ka upyog karke Bhagwat ki kahaniyon ko bahut hi rochak tarike se sunate hain. Unke YouTube channel par croro views hain. Woh yuvaon mein bahut popular hain.",
    work: ["Bhagwat Katha", "YouTube pravachan", "Yuva prerna", "Satsang", "Dharm prachar"],
    followers: "2 Crore+",
    youtube: "Aniruddhacharya Ji",
    category: "Katha Vachak",
    color: "#FF7000",
    bgColor: "from-orange-900 to-yellow-700"
  },
  {
    id: 14,
    name: "Swami Chinmayananda",
    title: "Chinmaya Mission Ke Sansthapak",
    location: "Kerala / Mumbai",
    born: "8 May 1916 - 3 August 1993",
    image: "/swami ji.jpg",
    shortDesc: "Chinmaya Mission ke sansthapak, Vedanta ke mahaan pracharak",
    fullDesc: "Swami Chinmayananda Chinmaya Mission ke sansthapak the. Unhone Vedanta ko aadhunik bhasha mein samjhaya. Unke pravachan aur books aaj bhi bahut popular hain. Unhone poore vishwa mein Vedanta ke prachar ke liye Chinmaya Mission ki sthapna ki. Unke shishya aaj bhi unke kaam ko aage badha rahe hain.",
    work: ["Vedanta pravachan", "Chinmaya Mission", "Upanishad vyakhya", "Geeta shiksha", "Adhyatmik lekhan"],
    followers: "5 Crore+",
    youtube: "Chinmaya Mission",
    category: "Vedanta Guru",
    color: "#CC5500",
    bgColor: "from-stone-900 to-orange-700"
  },
  {
    id: 15,
    name: "Swami Ramsukhdasji",
    title: "Gita Pravachak",
    location: "Rishikesh, Uttarakhand",
    born: "1904 - 2005",
    image: "/ramsukhdev.jpg",
    shortDesc: "Bhagwat Geeta ke mahaan vyakhyakaar, 'Sadhak Sanjivani' ke lekhak",
    fullDesc: "Swami Ramsukhdasji Maharaj Bhagwat Geeta ke ek mahaan vyakhyakaar the. Unhone 'Sadhak Sanjivani' naam ki Geeta ki tika likhi jo bahut prasiddh hai. Woh Gita Press Gorakhpur se jude the. Unka jeevan sadgi aur tyag ka prateek tha. 101 saal ki aayu mein unhone samadhi li.",
    work: ["Geeta pravachan", "Sadhak Sanjivani lekhan", "Adhyatmik shiksha", "Gita Press seva", "Satsang"],
    followers: "2 Crore+",
    youtube: "Gita Press",
    category: "Vedanta Guru",
    color: "#E05500",
    bgColor: "from-red-900 to-amber-700"
  },
  {
    id: 16,
    name: "Osho (Rajneesh)",
    title: "Aadhunik Mystic aur Philosopher",
    location: "Pune, Maharashtra",
    born: "11 December 1931 - 19 January 1990",
    image: "/osho.jpg",
    shortDesc: "Aadhunik mystic aur philosopher, 600+ books ke lekhak",
    fullDesc: "Osho, jinka asli naam Chandra Mohan Jain tha, ek prasiddh aadhunik mystic aur philosopher the. Unke pravachan mein dharm, philosophy, psychology aur meditation ka anokha sangam tha. Unki 600 se zyada books hain. Pune mein unka Osho International Meditation Resort aaj bhi chalata hai. Unke vichar aaj bhi duniya bhar mein popular hain.",
    work: ["Meditation shiksha", "Philosophical pravachan", "Books lekhan", "Osho International", "Dynamic Meditation"],
    followers: "3 Crore+",
    youtube: "Osho International",
    category: "Mystic",
    color: "#FF4400",
    bgColor: "from-red-900 to-orange-800"
  }
];

export const categories = [...new Set(babas.map(b => b.category))];
